//import components
import ContactForm from "../components/ContactForm";

const ContactPage = () => {
  return (
    <>
      <div className="flex flex-col max-w-xl mx-auto w-full items-center overflow-hidden pt-32">
        <ContactForm />
      </div>
    </>
  );
};

export default ContactPage;
